import { DEPOSIT_LIMIT_ACTION_TYPE } from "./deposit-limit.action";

export const DEPOSIT_LIMIT_MESSAGE_CONTEXT = {
	getAll: DEPOSIT_LIMIT_ACTION_TYPE.getAll,
	update: DEPOSIT_LIMIT_ACTION_TYPE.update,
	delete: DEPOSIT_LIMIT_ACTION_TYPE.remove,
	getUnconfirmed: DEPOSIT_LIMIT_ACTION_TYPE.getUnconfirmed,
	acceptUnconfirmed: DEPOSIT_LIMIT_ACTION_TYPE.acceptUnconfirmed,
	declineUnconfirmed: DEPOSIT_LIMIT_ACTION_TYPE.declineUnconfirmed,
};

export const SGA_DEPOSIT_LIMIT_DIALOG_ID = "sga-deposit-limit";

export const HGC_DEPOSIT_LIMIT_80_ID = "hgc-deposit-limit-80";

export const DEPOSIT_LIMIT_100_ID = "deposit-limit-100";

export const NET_DEPOSIT_LIMIT_100_ID = "net-deposit-limit-100";
